export const HOST = process.env.REACT_APP_API_URL;
export const WAPI = process.env.REACT_APP_WAPI_URL;
export const VERSION = 'api/v1/';

const APP_URL = {
    // AUTH
    LOGIN: `${HOST}${VERSION}auth/login/`,
    RECOVERYPASS: `${HOST}${VERSION}agent/recoveryPass/`,
    WAPI_ISLOGIN: `${WAPI}islogin/`,

    // PARAMETER
    LISTPARAMETER: `${HOST}${VERSION}admin/parameter/list/`,
    SEARCHTYPECATEGORY: `${HOST}${VERSION}admin/parameter/searchtypecategory/`,
    CREATEPARAMETER: `${HOST}${VERSION}admin/parameter/create/`,
    DELETEPARAMETER: `${HOST}${VERSION}admin/parameter/deleteparameter/`,
    LISTREQUESTFORTYPE: `${HOST}${VERSION}admin/parameter/listRequestForType/`,

    // USERS
    LISTUSERS: `${HOST}${VERSION}admin/users/list/`,
    LISTUSERSAUTOCOMPLETE: `${HOST}${VERSION}admin/users/listUserAutocomplete/`,
    CREATEUSERS: `${HOST}${VERSION}admin/users/create/`,
    UPDATEUSERS: `${HOST}${VERSION}admin/users/update/`,
    UPDATESTATUS: `${HOST}${VERSION}admin/users/updateStatus/`,
    UPDATEPASS: `${HOST}${VERSION}admin/users/updatePass/`,

    //tickets
    LISTTICKETS: `${HOST}${VERSION}admin/tickets/list/`,
    LISTTICKETSTYPE: `${HOST}${VERSION}admin/tickets/listType/`,
    LISTTICKETSUSER: `${HOST}${VERSION}admin/tickets/listUser/`,
    LISTTICKETSUSERSTATUS: `${HOST}${VERSION}admin/tickets/listUserStatus/`,
    SEARCHPRIORITY: `${HOST}${VERSION}admin/tickets/searchPriority/`,
    CREATETICKET: `${HOST}${VERSION}admin/tickets/create/`,
    DETAILSTICKET: `${HOST}${VERSION}admin/tickets/listDetails/`,
    QUALIFICATIONTICKET: `${HOST}${VERSION}admin/tickets/listQualification/`,
    SAVEQUALIFICATION: `${HOST}${VERSION}admin/tickets/saveQualification/`,
    CREATEDETAILSTICKET: `${HOST}${VERSION}admin/tickets/createDetails/`,
    LISTUPLOADSTICKET: `${HOST}${VERSION}admin/tickets/listUpload/`,
    CREATEUPLOADTICKETS: `${HOST}${VERSION}admin/tickets/createUpload/`,
    EXPORTDATA: `${HOST}${VERSION}admin/tickets/exportData`,
    DELETEFILESXLXS: `${HOST}${VERSION}admin/tickets/deleteFileXLXS`,
    FILTERDATATICKETS: `${HOST}${VERSION}admin/tickets/FilterDataTickets`,
    TOTALTICKETS: `${HOST}${VERSION}admin/tickets/totalTickets`,
    LISTCLIENTESPAGADOSTICKETS: `${HOST}${VERSION}admin/soporte/tickets/clientes-pagados`,

    // MODULES
    LISTMODULES: `${HOST}${VERSION}admin/modules/list/`,
    CREATEMODULES: `${HOST}${VERSION}admin/modules/create/`,
    UPDATEMODULES: `${HOST}${VERSION}admin/modules/update/`,
    UPDATESTATUSMODULES: `${HOST}${VERSION}admin/modules/updatestatus/`,
    // PRODUCT
    LISTPRODUCT: `${HOST}${VERSION}admin/modules/listProduct/`,
    UPDATEPRODUCT: `${HOST}${VERSION}admin/modules/updateproduct/`,
    UPDATESTATUSPRODUCT: `${HOST}${VERSION}admin/modules/updatestatusproduct/`,

    // STUDENTS
    CREATESTUDENTS: `${HOST}${VERSION}admin/students/createstudents/`,
    LISTSTUDENTS: `${HOST}${VERSION}admin/students/liststudents/`,
    LISTSTUDENTSREGISTRATION: `${HOST}${VERSION}admin/students/liststudentregistration/`,
    UPDATESTUDENTS: `${HOST}${VERSION}admin/students/updatestudents/`,
    // STUDENTS REGISTRATION
    SEARCHSTUDENTS: `${HOST}${VERSION}admin/students/searchstudent/`,
    SEARCHCOURSE: `${HOST}${VERSION}admin/students/searchcourse/`,
    SEARCHCOURSEDESCRIPTION: `${HOST}${VERSION}admin/students/searchcoursedescription/`,
    STUDENTENROLLMENT: `${HOST}${VERSION}admin/students/studentenrollment/`,
    LISTTEACHERENROLLMENT: `${HOST}${VERSION}admin/students/listteacherenrollment/`,
    UPLOADFILEPRINT: `${HOST}${VERSION}admin/students/uploadFingerPrint/`,
    LISTSTUDENTSAUTOCOMPLETE: `${HOST}${VERSION}admin/students/liststudentsAutoComplete/`,
    SEARCHREGISTRATION: `${HOST}${VERSION}admin/students/searchregistration/`,
    SEARCHREGISTRATIONSTUDENTS: `${HOST}${VERSION}admin/students/searchregistrationstudents/`,
    UPDATEREGISTRATIONSTUDENTS: `${HOST}${VERSION}admin/students/updateregistrationstudents/`,

    // TEACHER
    LISTTEACHER: `${HOST}${VERSION}admin/teacher/listTeacher/`,
    CREATETEACHER: `${HOST}${VERSION}admin/teacher/create/`,
    UPDATETEACHER: `${HOST}${VERSION}admin/teacher/update/`,
    LISTTEACHERAUTOCOMPLETE: `${HOST}${VERSION}admin/teacher/listTeacherAutoComplete/`,
    // TEACHER REGISTRATION
    SEARCHTYPECATEGORYTEACHER: `${HOST}${VERSION}admin/parameter/searchtypecategoryteacher/`,
    SEARCHTEACHER: `${HOST}${VERSION}admin/teacher/searchTeacher/`,
    LISTMODULETEACHER: `${HOST}${VERSION}admin/teacher/listModuleTeacher/`,
    DELETEMODULETEACHER: `${HOST}${VERSION}admin/teacher/deleteModuleTeacher/`,
    MODULETEACHER: `${HOST}${VERSION}admin/teacher/moduleTeacher/`,
    // LIST ESTUDENTS TEACHER
    LISTSTUDENTSTEACHER: `${HOST}${VERSION}admin/teacher/listestudentsteacher/`,
    SAVEEVIDENCECOURSE: `${HOST}${VERSION}admin/teacher/saveevidencecourse/`,
    SEARCHEVIDENCE: `${HOST}${VERSION}admin/teacher/searchevidence/`,
    SEARCHSESSION: `${HOST}${VERSION}admin/teacher/searchsession/`,
    UPDATESTATUSEVIDENCE: `${HOST}${VERSION}admin/teacher/updatestatusevidence/`,

    // REPORT
    LISTSTUDENTHOURS: `${HOST}${VERSION}admin/reports/listStudentHours/`,
    LISTSTUDENTDATE: `${HOST}${VERSION}admin/reports/listStudentDate/`,
    LISTSTUDENTHOURSID: `${HOST}${VERSION}admin/reports/listStudentHoursid/`,
    // ATTENDANT
    SEARCHATTENDANT: `${HOST}${VERSION}admin/attendant/searchattendant/`,

    //NOTIFY
    CREATENOTIFYALL: `${HOST}${VERSION}admin/parameter/notifyWhastsappAll/`,
    CREATENOTIFYMODULE: `${HOST}${VERSION}admin/parameter/notifyWhastsappModule/`,
    CREATENOTIFYINDIVIDUAL: `${HOST}${VERSION}admin/parameter/notifyWhastsappIndividual/`,
    CREATENOTIFYPRIVATE: `${HOST}${VERSION}admin/parameter/notifyWhastsappPrivate/`,
    LISTNOTIFYALL: `${HOST}${VERSION}admin/parameter/listNotifyWhastsapp/`,
    LISTNOTIFYWHATSAPPATTENDANT: `${HOST}${VERSION}admin/parameter/listNotifyWhastsappAttendant/`,
}

export default APP_URL
